import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { View, Spin } from '@components';
import styled from 'styled-components';

const ScrollableDiv = styled.div`
  height: ${(props) => props.height};
  overflow: auto;
`;

const ViewSpin = styled(View)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const InfiniteScroller = ({ children, height = '650px', ...otherProps }) => (
  <ScrollableDiv id='scrollableDiv' height={height}>
    <InfiniteScroll
      scrollableTarget='scrollableDiv'
      scrollThreshold={0.99}
      loader={
        <ViewSpin>
          <Spin />
        </ViewSpin>
      }
      {...otherProps}
    >
      {children}
    </InfiniteScroll>
  </ScrollableDiv>
);

export default InfiniteScroller;
